import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPresentationTrendlineUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99967 1.99992H5.59967C4.1062 1.99992 3.35946 1.99992 2.78903 2.29057C2.28727 2.54623 1.87932 2.95418 1.62366 3.45594C1.33301 4.02637 1.33301 4.77311 1.33301 6.26658V7.73325C1.33301 9.22672 1.33301 9.97346 1.62366 10.5439C1.87932 11.0457 2.28727 11.4536 2.78903 11.7093C3.35946 11.9999 4.1062 11.9999 5.59967 11.9999H10.3997C11.8931 11.9999 12.6399 11.9999 13.2103 11.7093C13.7121 11.4536 14.12 11.0457 14.3757 10.5439C14.6663 9.97346 14.6663 9.22672 14.6663 7.73325V6.26659C14.6663 4.77311 14.6663 4.02637 14.3757 3.45594C14.12 2.95418 13.7121 2.54623 13.2103 2.29057C12.6399 1.99992 11.8931 1.99992 10.3997 1.99992H7.99967ZM7.99967 1.99992V1.33325M3.99967 14.6666L5.33301 11.9999M11.9997 14.6666L10.6663 11.9999M4.66634 8.99992C5.15015 7.713 6.041 6.63552 7.19237 5.9447L7.35817 5.84522L8.64117 8.15462L8.80697 8.05514C9.95835 7.36432 10.8492 6.28683 11.333 4.99992",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPresentationTrendlineUp);
export default ForwardRef;
